import {translate} from "../../../../../helper/translate";
import {PREMIUM_TYPE_BASIC, PREMIUM_TYPE_PRO, PREMIUM_TYPE_STARTER, PREMIUM_TYPE_ULTIMATE} from "../const/premium_types.const";

class StylesManager {
    styles = [
        {
            name: translate('Generic 1'),
            conversion_style: 'inpainting_generic_1',
            type: PREMIUM_TYPE_BASIC,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Generic 2'),
            conversion_style: 'inpainting_generic_2',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Generic 3'),
            conversion_style: 'inpainting_generic_3',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic/sidebar@4x.png`),
                },
            }
        },
        {
            name: translate('Generic 4'),
            conversion_style: 'inpainting_generic_4',
            type: PREMIUM_TYPE_ULTIMATE,
            path: {
                '1x': require(`../assets/images/creator_studio_styles/realistic/1x.jpg`),
                '2x': require(`../assets/images/creator_studio_styles/realistic/2x.jpg`),
                '3x': require(`../assets/images/creator_studio_styles/realistic/3x.jpg`),
                '4x': require(`../assets/images/creator_studio_styles/realistic/4x.jpg`),
                sidebar:  {
                    '1x': require(`../assets/images/creator_studio_styles/realistic/sidebar@1x.png`),
                    '2x': require(`../assets/images/creator_studio_styles/realistic/sidebar@2x.png`),
                    '3x': require(`../assets/images/creator_studio_styles/realistic/sidebar@3x.png`),
                    '4x': require(`../assets/images/creator_studio_styles/realistic/sidebar@4x.png`),
                },
            }
        },
    ];

    constructor() {
    }

    getStylesByType(type) {
        return this.styles.filter(obj => {
            return obj.type === type
        })
    }

    getStylesByTypeFilteredForEducation(type) {
        return this.styles.filter(obj => {
            return obj.type === type && obj.nsfw !== true
        })
    }

    getStyleByName(name) {
        return this.styles.find(style => style.conversion_style === name);
    }
}

export default new StylesManager()
